import config from '@config'

const isMatches = (string: string, target: string): boolean => new RegExp(`${string}`).test(target)

const getDomain = (): string => location.hostname

const retailerPartnerNumber = (): number | null => {
  const domain = getDomain()

  const entry = Object.entries(config.resolve.retailerPartnerNumber).find(([key]) => isMatches(key, domain))
  const [_, number] = entry ?? [0, null]

  return number
}

/**
 * Determines if two-step search is allowed based on retailer partner number and marketing carrier code
 * @param retailerPartnerNumber The retailer partner number
 * @param marketingCarrierCode Optional marketing carrier code
 * @returns Boolean indicating if two-step search is allowed
 */
const isTwoStepSearchAllowed = (
  retailerPartnerNumber: number | string,
  marketingCarrierCode?: string | null,
): boolean => {
  if (marketingCarrierCode) {
    return !!config.twoStepSearch.byRpnAndCarrier[retailerPartnerNumber]?.includes(marketingCarrierCode)
  }
  return config.twoStepSearch.byRpn.includes(Number(retailerPartnerNumber))
}

export default {
  retailerPartnerNumber,
  isTwoStepSearchAllowed,
}
